import Post from '../api'

// 货币列表 
export const GetCurrencyLiSt = params => {
  return Post('GetGlobalCurrencyList', params)
}
